import { createAction } from 'redux-actions';

export const getSettingCustomColorRequested = createAction('GET_SETTING_CUSTOM_COLOR_REQUEST');
export const getSettingCustomColorReceived = createAction('GET_SETTING_CUSTOM_COLOR_RECEIVED');
export const getSettingCustomColorReceiveFailure = createAction('GET_SETTING_CUSTOM_COLOR_RECEIVE_FAILURE');
export const getSettingCustomColorClear = createAction('GET_SETTING_CUSTOM_COLOR_CLEAR');

export const updateSettingCustomColorRequested = createAction('UPDATE_SETTING_CUSTOM_COLOR_REQUEST');
export const updateSettingCustomColorReceived = createAction('UPDATE_SETTING_CUSTOM_COLOR_RECEIVED');
export const updateSettingCustomColorReceiveFailure = createAction('UPDATE_SETTING_CUSTOM_COLOR_RECEIVE_FAILURE');
export const updateSettingCustomColorClear = createAction('UPDATE_SETTING_CUSTOM_COLOR_CLEAR');

export const getSettingCustomTextRequested = createAction('GET_SETTING_CUSTOM_TEXT_REQUEST');
export const getSettingCustomTextReceived = createAction('GET_SETTING_CUSTOM_TEXT_RECEIVED');
export const getSettingCustomTextReceiveFailure = createAction('GET_SETTING_CUSTOM_TEXT_RECEIVE_FAILURE');
export const getSettingCustomTextClear = createAction('GET_SETTING_CUSTOM_TEXT_CLEAR');

export const updateSettingCustomTextRequested = createAction('UPDATE_SETTING_CUSTOM_TEXT_REQUEST');
export const updateSettingCustomTextReceived = createAction('UPDATE_SETTING_CUSTOM_TEXT_RECEIVED');
export const updateSettingCustomTextReceiveFailure = createAction('UPDATE_SETTING_CUSTOM_TEXT_RECEIVE_FAILURE');
export const updateSettingCustomTextClear = createAction('UPDATE_SETTING_CUSTOM_TEXT_CLEAR');

export const getSettingCustomCommentRequest = createAction('GET_SETTING_CUSTOM_COMMENT_REQUEST');
export const getSettingCustomCommentReceived = createAction('GET_SETTING_CUSTOM_COMMENT_RECEIVED');
export const getSettingCustomCommentReceiveFailure = createAction('GET_SETTING_CUSTOM_COMMENT_RECEIVE_FAILURE');
export const getSettingCustomCommentClear = createAction('GET_SETTING_CUSTOM_COMMENT_CLEAR');

export const updateSettingCustomCommentRequest = createAction('UPDATE_SETTING_CUSTOM_COMMENT_REQUEST');
export const updateSettingCustomCommentReceived = createAction('UPDATE_SETTING_CUSTOM_COMMENT_RECEIVED');
export const updateSettingCustomCommentReceiveFailure = createAction('UPDATE_SETTING_CUSTOM_COMMENT_RECEIVE_FAILURE');
export const updateSettingCustomCommentClear = createAction('UPDATE_SETTING_CUSTOM_COMMENT_CLEAR');

export const getSettingCustomTimerctrlRequest = createAction('GET_SETTING_CUSTOM_TIMERCTRL_REQUEST');
export const getSettingCustomTimerctrlReceived = createAction('GET_SETTING_CUSTOM_TIMERCTRL_RECEIVED');
export const getSettingCustomTimerctrlReceiveFailure = createAction('GET_SETTING_CUSTOM_TIMERCTRL_RECEIVE_FAILURE');
export const getSettingCustomTimerctrlClear = createAction('GET_SETTING_CUSTOM_TIMERCTRL_CLEAR');

export const updateSettingCustomTimerctrlRequest = createAction('UPDATE_SETTING_CUSTOM_TIMERCTRL_REQUEST');
export const updateSettingCustomTimerctrlReceived = createAction('UPDATE_SETTING_CUSTOM_TIMERCTRL_RECEIVED');
export const updateSettingCustomTimerctrlReceiveFailure = createAction('UPDATE_SETTING_CUSTOM_TIMERCTRL_RECEIVE_FAILURE');
export const updateSettingCustomTimerctrlClear = createAction('UPDATE_SETTING_CUSTOM_TIMERCTRL_CLEAR');

